"use client";

import { useEffect } from "react";
import { reportSystemError } from "@/lib/systemErrors/reportSystemError";
import { shouldReportGlobalError } from "@/lib/systemErrors/shouldReportGlobalError";

export default function SystemErrorGlobalReporter() {
  useEffect(() => {
    const onError = (event) => {
      const message =
        event?.message ||
        event?.error?.message ||
        (typeof event?.error === "string" ? event.error : "");
      if (!shouldReportGlobalError(message)) return;
      reportSystemError({
        phase: "global",
        code: "GLOBAL_UI_ERROR",
        message: String(message).slice(0, 2000),
        details: {
          filename: event?.filename || null,
          lineno: event?.lineno || null,
          colno: event?.colno || null,
        },
      });
    };

    const onUnhandledRejection = (event) => {
      const reason = event?.reason;
      const message =
        (reason && typeof reason === "object" && reason.message) ||
        String(reason || "Unhandled promise rejection");
      if (!shouldReportGlobalError(message)) return;
      reportSystemError({
        phase: "global",
        code: "GLOBAL_UNHANDLED_REJECTION",
        message: String(message).slice(0, 2000),
      });
    };

    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onUnhandledRejection);
    return () => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onUnhandledRejection);
    };
  }, []);

  return null;
}
